import { store } from '../../../../../../../resources/frontend/js/store/index';

export const clearParameter = (parameter) => {
    let parameters = getParameters();
    delete parameters[parameter];
    let parametersString = '';

    for (const item in parameters) {
        const string = `${item}=${parameters[item]}&`;
        parametersString += string;
    }

    parametersString = parametersString.replace(/&$/, '');

    const location = window.location.protocol + '//' + window.location.host + window.location.pathname + '?' + parametersString;
    history.replaceState({ path: location }, '', location);
};

export const updateParameter = (parameter, value) => {
    if (!store.state.page.browserBackButton) return;

    let parameters = getParameters();
    parameters[parameter] = value;
    let parametersString = '';

    for (const item in parameters) {
        const string = `${item}=${parameters[item]}&`;
        parametersString += string;
    }

    parametersString = parametersString.replace(/&$/, '');

    const location = window.location.protocol + '//' + window.location.host + window.location.pathname + '?' + parametersString;
    window.history.pushState({path: location}, '', location);
};

export const getParameters = () => {
    let parametersString = window.location.search.substring(1).replace(/&$/, '');
    const parametersList = parametersString.split('&');
    let parameters = {};

    parametersList.forEach(parameter => {
        if(parameter !== '') {
            const data = parameter.split('=');
            const key = data[0];
            const value = data[1];
            parameters[key] = value;
        }
    });

    return parameters;
};
